export function copyText(text){
  navigator.clipboard.writeText(text)
}
